<mat-form-field
  appearance="outline"
  [subscriptSizing]="subscriptSizing"
  class="country-select-field"
  [class.mat-form-field-invalid]="showInvalidState()"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <span matPrefix class="country-select-prefix" *ngIf="value">
    <img
      class="country-select-flag"
      [src]="getCountryFlagUrl(value)"
      width="20"
      height="15"
      alt=""
    />
  </span>
  <input
    #countryInput
    matInput
    type="text"
    [formControl]="searchControl"
    [matAutocomplete]="countryAuto"
    [required]="showRequiredMarker()"
    autocomplete="off"
    role="combobox"
    (click)="onInputClick()"
    (blur)="onInputBlur()"
  />
  <mat-icon
    matSuffix
    class="country-select-chevron"
    aria-hidden="true"
    (mousedown)="$event.preventDefault()"
    (click)="onChevronClick()"
  >
    arrow_drop_down
  </mat-icon>
  <mat-autocomplete
    #countryAuto="matAutocomplete"
    (optionSelected)="onOptionSelected($event)"
  >
    <mat-option
      *ngFor="let country of filteredCountries; trackBy: trackByCountryCode"
      [value]="country"
    >
      <img
        class="country-select-flag"
        [src]="getCountryFlagUrl(country.alpha2Code)"
        width="20"
        height="15"
        alt=""
      />
      {{ getCountryName(country.alpha2Code) }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
